import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, createVNode as _createVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "content-block lined"
}
const _hoisted_2 = { class: "box" }
const _hoisted_3 = ["^src"]
const _hoisted_4 = ["innerHTML"]
const _hoisted_5 = { key: 1 }

import { computed, markRaw, onMounted } from 'vue';
import { useStore } from 'vuex';
import { Actions, BazaarState } from '@/models/store.model';
import { Content } from '@/models/content.model';
import { DrawerMutations } from '@/core/drawer.store';
import ContentForm from './ContentForm.vue';
import { Auth } from '@/models/auth.model';
import PencilIcon from '../icons/PencilIcon.vue';
import Map from '../common/Map.vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'ContentBlock',
  props: {
  slug: {
    type: String,
    required: true,
  },
},
  setup(__props) {



const store = useStore<BazaarState>();

const content = computed<Content>(() => store.getters.getContent(__props.slug));
const auth = computed<Auth>(() => store.state.auth);

onMounted(() => {
  store.dispatch(Actions.GetContents);
});

const edit = () => {
  store.commit(DrawerMutations.OpenDrawer, {
    drawer: markRaw(ContentForm),
    data: {
      id: content.value.id,
    },
  });
};

const getContent = (content: Content): string => {
  return content.content.replace(/\n\n/g, '').replace(/\n/g, '<br/>');
};
const getImage = (path: string): string => {
  return path.indexOf('data/') !== -1 ? path : `/data/${path}`;
};

return (_ctx: any,_cache: any) => {
  return (content.value)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("h2", null, _toDisplayString(content.value.title), 1),
        _createElementVNode("section", _hoisted_2, [
          (content.value.slug === 'adres')
            ? (_openBlock(), _createBlock(Map, { key: 0 }))
            : _createCommentVNode("", true),
          (content.value.image)
            ? (_openBlock(), _createElementBlock("img", {
                key: 1,
                "^src": getImage(content.value.image),
                class: "content-block-image"
              }, null, 8, _hoisted_3))
            : _createCommentVNode("", true),
          _createElementVNode("div", {
            innerHTML: getContent(content.value)
          }, null, 8, _hoisted_4),
          (auth.value.isUser)
            ? (_openBlock(), _createElementBlock("button", {
                key: 2,
                class: "option small icon edit-button",
                onClick: edit
              }, [
                _createVNode(PencilIcon, { size: 12 })
              ]))
            : _createCommentVNode("", true)
        ])
      ]))
    : (_openBlock(), _createElementBlock("div", _hoisted_5, "Content " + _toDisplayString(__props.slug) + " could not be found.", 1))
}
}

})